import Text from '@components/Text';
import styled from '@emotion/styled';

import useAttendanceEvent from '../../hooks/useAttendanceEvent';

interface Props {
    eventId: string;
}

function AttendanceNote({ eventId }:Props) {
    const { policy } = useAttendanceEvent(eventId);
    if (policy?.bottomNote) {
        return (
            <Container>
                <Contents as='div' dangerouslySetInnerHTML={{ __html: policy.bottomNote }}/>
            </Container>
        );
    }
    return null;
}

const Container = styled.div`
    background-color: var(--color-gray2);
    border-radius: 8px;
    margin: 0 20px;
    padding: 12px;
    width: calc(100% - 40px);
`;

const Contents = styled(Text)`
    word-break:break-all;
`;

export default AttendanceNote;
